import type { ReportedPostRepository } from '../repositories/reported_post_repository'

export class DeleteReportedPostUseCase {
  constructor(private readonly repository: ReportedPostRepository) {}

  execute(id: string): Promise<void> {
    return this.repository.delete(id)
  }
}
